export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'The Product',
  headline: 'Welcome To CallOn',
  description:
    `CallOn is multiplatform mobile application 
    that lets you make royal quality calls to any phone 
    number all over the world. 

    CallOn uses your cell phone’s internet connection.
    Your friends and family always get calls from your 
    personal phone number.

    Call anyone to any phone number worldwide even 
    if he doesn't have CallOn app installed.
    We provide the best prices on the market 
    with such high quality!`,
  buttonLabel: 'Get Started',
  imgStart: '',
  img: require('../../images/firstScreen.png'),
  alt: 'Credit Card',
  start: '',
  id: 'one'
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Instant Setup',
  headline: 'Extremely quick onboarding process',
  description:
    "Once you've joined, our team of specialist will reach out to you and get you set up in minutes.",
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/thirdScreen.png'),
  alt: 'Vault',
  start: '',
  id: 'two'
};

export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'No Hidden Charges',
  headline: 'See Total Price Before Calling',
  prices: true,
  buttonLabel: 'Search',
  imgStart: 'start',
  img: require('../../images/secondScreen.png'),
  alt: 'Vault',
  start: 'true',
  id: 'three'
};

export const homeObjFour = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Secure Database',
  headline: 'All your data is stored on our secure server',
  description:
    'You will never have to worry about your information getting leaked. Our team of security experts will ensure your records are kept safe.',
  buttonLabel: 'Sign Up Now',
  imgStart: 'start',
  img: require('../../images/svg-3.svg'),
  alt: 'Vault',
  start: 'true',
  id: 'four'
};
